var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
export class FiltersHelper {
  constructor(filters) {
    __publicField(this, "DESKTOP_BREAKPOINT", "1024px");
    __publicField(this, "closeFiltersBtnSelector", "[id=close-filters-btn]");
    __publicField(this, "showFiltersBtnSelector", "#show-filters-btn");
    this.filters = filters;
    this.closeFiltersBtn = document.querySelectorAll(this.closeFiltersBtnSelector);
  }
  init() {
    $(document).on("click", this.showFiltersBtnSelector, () => {
      this.show();
      this.closeFiltersBtn[0].focus();
    });
    this.closeFiltersBtn.forEach((element) => {
      element.addEventListener("click", () => {
        this.hide();
      });
    });
    window.matchMedia(`(min-width: ${this.DESKTOP_BREAKPOINT})`).addEventListener("change", () => {
      this.hide();
    });
  }
  show() {
    this.filters.classList.remove("hidden");
    document.body.classList.add("overflow-hidden");
  }
  hide() {
    this.filters.classList.add("hidden");
    document.body.classList.remove("overflow-hidden");
  }
}
export function createFiltersHelper(filters) {
  return new FiltersHelper(filters);
}
